export const CAP_default = [{
    strike_cap : 2,
    prime_de_couverture : 10
}]



// WEBPACK FOOTER //
// ./src/shared/Cotation/chart/data/default/Cap.ts